import { RealEstateOtherCost } from '../../../../@types/real-estate-api-types'
import { ContentStateInterface, OtherCostsInterface } from '../../../../@types/types'
import { EN, parseDecimal } from '../../../../i18next/decimal'

export const otherCostsToApp = (
  otherCosts: RealEstateOtherCost | undefined,
  defaultStateValues: ContentStateInterface
): OtherCostsInterface => {
  let options: boolean | undefined = defaultStateValues.heatingCostsOption
  if (otherCosts?.heatingCostsOption === 'heatingCostsNotIncluded') {
    options = false
  } else if (otherCosts?.heatingCostsOption === 'heatingCostsIncluded') {
    options = true
  }

  return {
    additionalCosts: otherCosts?.additionalCosts ?? defaultStateValues.additionalCosts,
    deposit: otherCosts?.deposit ?? defaultStateValues.deposit,
    heatingCosts: parseDecimal(otherCosts?.heatingCosts, EN) ?? defaultStateValues.heatingCosts,
    heatingCostsOption: options,
  }
}
